import { render, staticRenderFns } from "./expandDemand.vue?vue&type=template&id=531494be&scoped=true&"
import script from "./expandDemand.vue?vue&type=script&lang=js&"
export * from "./expandDemand.vue?vue&type=script&lang=js&"
import style0 from "./expandDemand.vue?vue&type=style&index=0&id=531494be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531494be",
  null
  
)

export default component.exports